import {
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE,
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_FAIL,
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_SUCCESS,
    GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT,
    GET_AZURE_CLOUD_RESOURCES,
    GET_AZURE_CLOUD_RESOURCES_SUCCESS,
    GET_AZURE_CLOUD_RESOURCES_FAIL,
    GET_AZURE_REFRESH,
    GET_AZURE_REFRESH_SUCCESS,
    GET_AZURE_REFRESH_FAIL,
    GET_AZURE_NOTIFICATION_CHANNELS,
    GET_AZURE_NOTIFICATION_CHANNELS_FAIL,
    GET_AZURE_NOTIFICATION_CHANNELS_SUCCESS,
    POST_AZURE_CREATE_RESOURCE_ALERTS,
    POST_AZURE_CREATE_RESOURCE_ALERTS_FAIL,
    POST_AZURE_CREATE_RESOURCE_ALERTS_SUCCESS,
    POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING,
    POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
    POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
    POST_AZURE_RESOURCE_SERVICE_MAPPING,
    POST_AZURE_RESOURCE_SERVICE_MAPPING_SUCCESS,
    POST_AZURE_RESOURCE_SERVICE_MAPPING_FAIL,
    GET_ALL_ORG_AZURE_RESOURCE_TYPES,
    GET_ALL_ORG_AZURE_RESOURCE_TYPES_FAIL,
    GET_ALL_ORG_AZURE_RESOURCE_TYPES_SUCCESS,
    GET_USER_RESCAN_STATUS_AZURE,
    GET_USER_RESCAN_STATUS_AZURE_FAIL,
    GET_USER_RESCAN_STATUS_AZURE_SUCCESS,

} from './actionTypes'

export const getAzureRefresh = () => ({
    type: GET_AZURE_REFRESH,
})

export const getAzureRefreshSuccess = azure_refresh => ({
    type: GET_AZURE_REFRESH_SUCCESS,
    payload: azure_refresh,
})

export const getAzureRefreshFail = error => ({
    type: GET_AZURE_REFRESH_FAIL,
    payload: error,
})

export const getAzureAllResourceAlertsPage = (page_filters) => ({
    type: GET_AZURE_ALL_RESOURCE_ALERTS_PAGE,
    payload: { page_filters }
})

export const getAzureAllResourceAlertsPageSuccess = azure_all_resource_alerts => ({
    type: GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
    payload: azure_all_resource_alerts,
})

export const getAzureAllResourceAlertsPageFail = error => ({
    type: GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_FAIL,
    payload: error,
})

export const getAzureAllResourceAlertsPageCount = (page_filters) => ({
    type: GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT,
    payload: { page_filters }
})

export const getAzureAllResourceAlertsPageCountSuccess = azure_all_resource_alerts => ({
    type: GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_SUCCESS,
    payload: azure_all_resource_alerts,
})

export const getAzureAllResourceAlertsPageCountFail = error => ({
    type: GET_AZURE_ALL_RESOURCE_ALERTS_PAGE_COUNT_FAIL,
    payload: error,
})

export const getAzureCloudResources = () => {
    return {
        type: GET_AZURE_CLOUD_RESOURCES,
    }
}

export const getAzureCloudResourcesSuccess = azure_cloudResources => ({
    type: GET_AZURE_CLOUD_RESOURCES_SUCCESS,
    payload: azure_cloudResources,
})

export const getAzureCloudResourcesFail = error => ({
    type: GET_AZURE_CLOUD_RESOURCES_FAIL,
    payload: error,
})

export const getAzureNotificationChannels = () => ({
    type: GET_AZURE_NOTIFICATION_CHANNELS,
})

export const getAzureNotificationChannelsSuccess = notification_channels => ({
    type: GET_AZURE_NOTIFICATION_CHANNELS_SUCCESS,
    payload: notification_channels,
})

export const getAzureNotificationChannelsFail = error => ({
    type: GET_AZURE_NOTIFICATION_CHANNELS_FAIL,
    payload: error,
})

export const postAzureCreateResourceAlerts = (data) => ({
    type: POST_AZURE_CREATE_RESOURCE_ALERTS,
    payload: { data }
})

export const postAzureCreateResourceAlertsSuccess = (alerts) => ({
    type: POST_AZURE_CREATE_RESOURCE_ALERTS_SUCCESS,
    payload: alerts
})

export const postAzureCreateResourceAlertsFail = error => ({
    type: POST_AZURE_CREATE_RESOURCE_ALERTS_FAIL,
    payload: error,
})


export const postAzureResourceOpsGenieTeamMapping = (data) => ({
    type: POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING,
    payload: { data }
})

export const postAzureResourceOpsGenieTeamMappingSuccess = azure_cloudResources => ({
    type: POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
    payload: azure_cloudResources,
})

export const postAzureResourceOpsGenieTeamMappingFail = error => ({
    type: POST_AZURE_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
    payload: error,
})


export const postAzureResourcePagerdutyServiceMapping = data => ({
    type: POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
    payload: { data }
})

export const postAzureResourcePagerdutyServiceMappingSuccess = azure_cloudResources => ({
    type: POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
    payload: azure_cloudResources,
})

export const postAzureResourcePagerdutyServiceMappingFail = error => ({
    type: POST_AZURE_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
    payload: error,
})

export const postAzureResourceServiceMapping = data => ({
    type: POST_AZURE_RESOURCE_SERVICE_MAPPING,
    payload: { data }
})

export const postAzureResourceServiceMappingSuccess = azure_cloudResources => ({
    type: POST_AZURE_RESOURCE_SERVICE_MAPPING_SUCCESS,
    payload: azure_cloudResources,
})

export const postAzureResourceServiceMappingFail = error => ({
    type: POST_AZURE_RESOURCE_SERVICE_MAPPING_FAIL,
    payload: error,
})


export const getAllOrgAzureResourceTypes = () => ({
    type: GET_ALL_ORG_AZURE_RESOURCE_TYPES
})

export const getAllOrgAzureResourceTypesSuccess = orgAzureResourceTypes => ({
    type: GET_ALL_ORG_AZURE_RESOURCE_TYPES_SUCCESS,
    payload: orgAzureResourceTypes,
})

export const getAllOrgAzureResourceTypesFail = error => ({
    type: GET_ALL_ORG_AZURE_RESOURCE_TYPES_FAIL,
    payload: error,
})

export const getAzureRefreshScanStatus = () => ({
    type: GET_USER_RESCAN_STATUS_AZURE,
})

export const getAzureRefreshScanStatusSuccess = azure_refresh_status => ({
    type: GET_USER_RESCAN_STATUS_AZURE_SUCCESS,
    payload: azure_refresh_status,
})

export const getAzureRefreshScanStatusFail = error => ({
    type: GET_USER_RESCAN_STATUS_AZURE_FAIL,
    payload: error,
})
